export const BumpaInstructiondata = [
  {
    id: 1,
    title:
      "Login into your Bumpa account. Use the web app:https://app.getbumpa.com",
  },
  {
    id: 2,
    title: `Navigate to the left-hand side menu, click on "Store," and then select "API Key`,
  },
  {
    id: 3,
    title: `On the API Key page, input "Fez" as the Token Name and click "Generate Key" to obtain your API Key. Copy the generated API Key`,
  },
  {
    id: 4,
    title:
      "Log in to the Fez account at `https://businessportal.fezdelivery.co/`",
  },
  {
    id: 5,
    title: `In the left-hand side menu, click on "Import from Bumpa", and select " Manage Keys"`,
  },
  {
    id: 6,
    title: `Input the "API Key" and click "Save Secret Key". You get a note that the API connection is successful.`,
  },
  {
    id: 7,
    title: `Click on "Import Orders" and easily move all pending orders. You can filter for the date range you want to ship.`,
  },
  {
    id: 8,
    title: `Select the orders you want to import and click “bulk import” when you have multiple orders or select the import button at the end column when it’s just an order. You will get “imported successfully”`,
  },
];
